var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "nestedForm",
      attrs: { "lazy-validation": "" },
      on: {
        input: function($event) {
          return _vm.onChangeValidation(_vm.valid)
        }
      },
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c(
        "div",
        { staticClass: "va-card mt-6" },
        [
          _c("div", { staticClass: "va-subtitle-s mb-6" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("policiesGroups.display")) +
                " " +
                _vm._s(_vm.$t("common.settings")) +
                " - "
            ),
            _c("img", {
              staticClass: "mx-2",
              staticStyle: { width: "20px", display: "inline" },
              attrs: {
                src: require("@/assets/images/deviceTypes/microsoft.svg"),
                alt: "windows logo"
              }
            }),
            _c("img", {
              staticClass: "mr-2",
              staticStyle: { width: "20px", display: "inline" },
              attrs: {
                src: require("@/assets/images/deviceTypes/android.svg"),
                alt: "android logo"
              }
            }),
            _c("span", { staticClass: "font-weight-medium font-italic" }, [
              _vm._v(" (" + _vm._s(_vm.$t("policiesGroups.winAndroid")) + ")")
            ])
          ]),
          _c("v-select", {
            staticClass: "mt-4 mb-4",
            attrs: {
              outlined: "",
              dense: "",
              attach: "",
              items: _vm.deviceDisplayModeOptions,
              "item-text": "text",
              "item-value": "value",
              label: _vm.$t("policiesFields.DeviceDisplayMode"),
              "hide-details": ""
            },
            on: { change: _vm.onChangeDeviceDisplayMode },
            model: {
              value: _vm.fields.DeviceDisplayMode,
              callback: function($$v) {
                _vm.$set(_vm.fields, "DeviceDisplayMode", $$v)
              },
              expression: "fields.DeviceDisplayMode"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }